/**
 * Time utility functions for UTC to local timezone conversion
 */

/**
 * Convert UTC date to local timezone for display
 * @param utcDate - UTC date string or Date object
 * @returns Date object in local timezone
 */
export function utcToLocal(utcDate: string | Date | null): Date | null {
  if (!utcDate) return null;
  
  const date = new Date(utcDate);
  if (isNaN(date.getTime())) return null;
  
  return date;
}

/**
 * Format UTC date for display in local timezone
 * @param utcDate - UTC date string or Date object
 * @returns Formatted date string in local timezone
 */
export function formatUtcToLocal(utcDate: string | Date | null): string {
  const localDate = utcToLocal(utcDate);
  if (!localDate) return '';
  
  return localDate.toLocaleString();
}

/**
 * Format UTC date for display with date only
 * @param utcDate - UTC date string or Date object
 * @returns Formatted date string in local timezone
 */
export function formatUtcToLocalDate(utcDate: string | Date | null): string {
  const localDate = utcToLocal(utcDate);
  if (!localDate) return '';
  
  return localDate.toLocaleDateString();
}

/**
 * Format UTC date for display with time only
 * @param utcDate - UTC date string or Date object
 * @returns Formatted time string in local timezone
 */
export function formatUtcToLocalTime(utcDate: string | Date | null): string {
  const localDate = utcToLocal(utcDate);
  if (!localDate) return '';
  
  return localDate.toLocaleTimeString();
}

/**
 * Convert local date to UTC for API calls
 * @param localDate - Local date string or Date object
 * @returns UTC date string
 */
export function localToUtc(localDate: string | Date | null): string | null {
  if (!localDate) return null;
  
  const date = new Date(localDate);
  if (isNaN(date.getTime())) return null;
  
  return date.toISOString();
}
